import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route, Router } from '@angular/router';
import { AUTH_CONTENT_ROUTE_CONFIG, AUTH_ROUTE_CONFIG } from '@core/constants/routes.constants';

import { EMPTY, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PreloadingStrategyService implements PreloadingStrategy {
  constructor(private router: Router) {}

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.path === AUTH_CONTENT_ROUTE_CONFIG.root) {
      return this.loadAuthorizedContentModule(load);
    }

    return load();
  }

  private loadAuthorizedContentModule(load: () => Observable<unknown>): Observable<unknown> {
    if (this.router.url.includes(AUTH_ROUTE_CONFIG.children.logIn)) {
      return load();
    }

    return EMPTY;
  }
}
